<template>
  <div>
    <el-drawer
      :visible.sync="treeDrawer"
      direction="rtl"
      size="30%"
      @close="cancelForm"
    >
      <!-- <el-collapse accordion v-model="activeCollapse">
        <div v-for="item in houseData" :key="item.houseId">
          <el-collapse-item :name="item.houseId">
            <template slot="title">
              <div class="title">{{ item.name }}</div>
            </template>
            <div class="top_select"> -->
      <el-tree
        :props="defaultProps"
        :data="treeData"
        :load="loadNode"
        lazy
        node-key="id"
        show-checkbox
        center
        ref="treeRef"
        :default-checked-keys="defaultCheckedNodes"
      >
      </el-tree>
      <!-- </div>
          </el-collapse-item>
        </div>
      </el-collapse> -->
      <div class="demo-drawer__footer">
        <el-button @click="cancelForm">取 消</el-button>
        <el-button type="primary" @click="editPermit" :loading="loading">{{
          loading ? '提交中 ...' : '确 定'
        }}</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { updateRolePermitRoleApi } from '@/api/user.js';
// import { getToken } from '@/utils/token';
export default {
  props: ['roleId'],
  inject: ['reload'],
  data() {
    return {
      activeCollapse: '',
      permitData: {},
      treeDrawer: false,
      treeData: [],
      houseData: [],
      defaultProps: {
        children: 'childs',
        label: 'name',
      },
      cancleMenuObj: {},
      loading: false,
      agentList: [],
      defaultCheckedNodes: [],
      checkNodesArr: [],
    };
  },
  watch: {
    activeCollapse(newValue) {
      // console.log(this.houseData, '数据发生了改变');
      this.fetchNodeData(newValue);
    },
  },
  mounted() {},
  methods: {
    async loadNode(node, resolve) {
      const { level } = node;
      if (level === 0) {
        console.log(this.treeData, 'treeData');
        resolve([...this.treeData]);
      } else {
        console.log(node, '节点');
      }
      // if (houseId) {
      //   const index = this.houseData.findIndex(
      //     (item) => item.houseId == houseId
      //   );
      //   if (this.houseData[index].childs.length > 0) return;
      //   const res = await getRolePermitApi({
      //     roleId: this.roleId,
      //     houseId,
      //   });
      //   if (res.code === 200) {
      //     let filterArr = res.data.filter((item) => item.permits);
      //     let obj = this.filterData(filterArr, houseId);
      //     console.log(obj, 'defaultCheckedNodes');
      //     this.$set(this.houseData[index], 'childs', obj.arr);
      //     this.$set(
      //       this.houseData[index],
      //       'defaultCheckedNodes',
      //       obj.defaultCheckedNodes
      //     );
      //     // this.treeData = arr;
      //   }
      // }
    },
    filterData(array, houseId) {
      const defaultCheckedNodes = [];
      let data = array.map((item) => {
        // item.defaultCheckedNodes = [];
        this.cancleMenuObj[item.menu.menuId] = [];
        return {
          name: item.menu.name,
          sortNum: item.menu.sortNum,
          superId: item.menu.superId.trim(),
          menuId: item.menu.menuId,
          childs: item.permits.map((child) => {
            child.id = `${houseId};${item.menu.menuId};${child.permitId}`; //设置唯一id
            child.menuId = item.menu.menuId;
            if (child.select === 1) {
              const index = this.checkNodesArr.findIndex(
                (child) => child.houseId == houseId
              );
              if (index == -1) {
                let obj = {
                  houseId,
                  roleId: this.roleId,
                  dctRolePermit: {
                    [item.menu.menuId]: [],
                  },
                };
                this.checkNodesArr.push(obj);
              } else {
                this.checkNodesArr[index].dctRolePermit[item.menu.menuId] = [];
              }

              defaultCheckedNodes.push(child.id); //为1表示勾选
            }
            return child;
          }),
        };
      });
      let arr = data
        .map((item) => {
          for (let i = 0; i < data.length; i++) {
            // console.log(item.superId,data[i].menuId)
            if (item.superId == data[i].menuId) {
              //item找到其父节点
              data[i].childs.push(item);
              item.flag = 1;
            }
          }
          // item.houseId = houseId
          return item;
        })
        .filter((item) => !item.flag)
        .sort((a, b) => {
          return a.sortNum - b.sortNum;
        });

      return { arr, defaultCheckedNodes };
    },
    cancelForm() {
      this.treeData = [];
      this.treeDrawer = false;
      this.activeCollapse = '';
    },
    async editPermit() {
      this.loading = true;
      console.log(this.$refs.treeRef, '树形数据');
      let allCheckedNodes = [];
      this.$refs.treeRef.forEach((itemDom) => {
        allCheckedNodes.push(...itemDom.getCheckedNodes(true, false));
      });

      console.log(allCheckedNodes, '选中的数据');
      let allNodes = [];
      if (this.checkNodesArr.length > 0) {
        allNodes = this.checkNodesArr;
      }
      if (allCheckedNodes.length > 0) {
        allCheckedNodes.forEach((key) => {
          let item = key.id;
          const nodeArr = item.split(';');
          // console.log(nodeArr, '节点数据');
          let houseId = nodeArr[0];
          const menuId = nodeArr[1];
          const permitId = nodeArr[2];
          const index = allNodes.findIndex((child) => child.houseId == houseId);
          let obj = { dctRolePermit: {}, houseId, roleId: this.roleId };
          if (index != -1) {
            //楼盘存在
            obj = allNodes[index];
            if (!obj.dctRolePermit[menuId]) {
              obj.dctRolePermit[menuId] = [];
            }
            obj.dctRolePermit[menuId].push(permitId);
            const selectedIndex = this.checkNodesArr.findIndex(
              (child) => child.houseId === houseId
            ); //之前被选中的houseIndex
            if (selectedIndex != -1) {
              console.log(selectedIndex, 'selectedIndex');
              obj.dctRolePermit = {
                ...this.checkNodesArr[selectedIndex].dctRolePermit,
                ...obj.dctRolePermit,
              };
            }
            console.log(index, '已有该数据', obj);
            allNodes[index] = obj;
          } else {
            console.log('不存在该数据');
            obj.dctRolePermit[menuId] = [permitId];
            allNodes.push(obj);
          }
        });
      }

      console.log(allNodes, 'allNodes');
      const res = await updateRolePermitRoleApi({
        allNodes,
        roleId: this.roleId,
      });
      this.loading = false;
      if (res.code === 200) {
        this.$message.success('修改成功');
        this.reload();
      }
    },
  },
};
</script>
<style lang="less">
.el-drawer__body {
  overflow: scroll;
}
.demo-drawer__footer {
  position: fixed;
  bottom: 20px;
  right: 20px;
}
.top_select {
  margin-left: 30px;
  .select {
    width: 500px;
    margin-bottom: 30px;
  }
}
.title {
  margin-left: 30px;
}
</style>